import React from 'react';
import { Card, Button } from 'react-bootstrap';

export default function BakeryJoin() {
  return (
    <div style={{ padding: '4rem 1rem 6rem 1rem', backgroundColor: '#fff8fa' }}>
      <Card
        className="shadow-sm mx-auto text-center p-4"
        style={{
          maxWidth: '700px',
          borderRadius: '15px',
          backgroundColor: '#fff',
        }}
      >
        <h2 className="fw-bold mb-3" style={{ color: '#FEA2C2' }}>
          Welcome to the Cakery Family
        </h2>

        <p style={{ fontSize: '1.1rem', color: '#444' }}>
          Whether you're an experienced cake artist or just starting your baking business, <strong>Cakery</strong> is your new partner in connecting with the right customers—and turning your cake creations into consistent income.
        </p>

        <p style={{ fontSize: '1.1rem', color: '#444' }}>
          We’re a startup dedicated to helping bakers like you <strong>get discovered, get booked, and get paid</strong>. With Cakery, you don’t just list your business—you get:
        </p>

        <div className="text-start my-3" style={{ fontSize: '1.05rem', color: '#555', paddingLeft: '1.5rem' }}>
          <ul style={{ listStyleType: 'none', padding: 0 }}>
            <li>🍰 <strong>A personalized bakery page</strong> with your own custom URL</li>
            <li>📸 <strong>Photo gallery</strong> to showcase your past work</li>
            <li>💵 <strong>Built-in pricing tools</strong> to automate quotes using your preferred strategy</li>
            <li>🎯 <strong>Access to active customers</strong> searching for cakes in your area</li>
            <li>🚀 <strong>Priority placement</strong> on our search page to help you stand out</li>
          </ul>
        </div>

        <p style={{ fontSize: '1.1rem', color: '#444' }}>
          Sign up today and enjoy your first <strong>3 months free</strong>—just <strong>$27/month</strong> after that.
        </p>

        <p style={{ fontSize: '1.1rem', color: '#444' }}>
          <strong>Ready to grow your business?</strong> Create your profile in minutes and start receiving custom quote requests right away.
        </p>

        <Button
          href="https://drive.google.com/file/d/1df1ooBvB679E81CGfx_Nf_HS1XIdmqgw/view?usp=share_link"
          target="_blank"
          rel="noopener noreferrer"
          className="rounded-pill px-4 py-2"
          style={{
            backgroundColor: '#2AACE3',
            border: 'none',
            fontWeight: 'bold',
            fontSize: '1.1rem',
          }}
        >
          📄 Download Step-by-Step Guide
        </Button>
      </Card>
    </div>
  );
}
